import { render } from "./Registers.vue?vue&type=template&id=fb23f3a0&scoped=true"
import script from "./Registers.vue?vue&type=script&lang=js"
export * from "./Registers.vue?vue&type=script&lang=js"

import "./Registers.vue?vue&type=style&index=0&id=fb23f3a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb23f3a0"],['__file',"src/components/Registers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fb23f3a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fb23f3a0', __exports__)) {
    api.reload('fb23f3a0', __exports__)
  }
  
  module.hot.accept("./Registers.vue?vue&type=template&id=fb23f3a0&scoped=true", () => {
    api.rerender('fb23f3a0', render)
  })

}


export default __exports__